import PermissionChecker from '../../../modules/auth/permissionChecker'
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

function EmptyTenantRoute ({
  component: Component,
  currentUser,
  currentTenant,
}) {
  const permissionChecker = new PermissionChecker(
    currentTenant,
    currentUser,
  )

  if (!permissionChecker.isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: '/auth/signin',
        }}
      />
    )
  }

  if (!permissionChecker.isEmptyTenant) {
    return <Navigate to="/" />
  }

  return (
    <>
      <Component />
      <Outlet />
    </>
  )
}

export default EmptyTenantRoute
